var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FFF8E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "#FFF8E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_229_124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 12C17.3281 12 15.8333 13.4948 15.8333 15.3333V35.3333C15.8333 37.1719 17.3281 38.6667 19.1667 38.6667H30.8333C32.6719 38.6667 34.1667 37.1719 34.1667 35.3333V15.3333C34.1667 13.4948 32.6719 12 30.8333 12H19.1667ZM25 32.8333C25.442 32.8333 25.866 33.0089 26.1785 33.3215C26.4911 33.634 26.6667 34.058 26.6667 34.5C26.6667 34.942 26.4911 35.3659 26.1785 35.6785C25.866 35.9911 25.442 36.1667 25 36.1667C24.558 36.1667 24.1341 35.9911 23.8215 35.6785C23.5089 35.3659 23.3333 34.942 23.3333 34.5C23.3333 34.058 23.5089 33.634 23.8215 33.3215C24.1341 33.0089 24.558 32.8333 25 32.8333Z",
    fill: "#FABC2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_229_124"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 26.6667,
    fill: "white",
    transform: "translate(15 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.3a0822c0d7c4360cd3f7b3b10a962150.svg";
export { ForwardRef as ReactComponent };